import { render, staticRenderFns } from "./ItemListRealSaleLayout.vue?vue&type=template&id=22db4eb4&scoped=true"
import script from "./ItemListRealSaleLayout.vue?vue&type=script&lang=js"
export * from "./ItemListRealSaleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db4eb4",
  null
  
)

export default component.exports